import { Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useQsFilters } from "../../hooks/filters"
import { FiltersBase } from "../../types"
import { TableAtlanti } from "./TableAtlanti"
import { useAtlantiList } from "../../hooks/atlanti"
import { useNavigate } from "react-router-dom"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "",
  } as FiltersBase)

export default function Atlanti() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useAtlantiList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Edizioni" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Atlanti</H1>
          <Button
            className="text-white"
            size="md"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/atlanti/atlanti/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value })
            }}
          />
        </Flex>
        <TableAtlanti
          atlanti={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
